module.exports = __webpack_public_path__ + "img/user-8.7d9de0e2.png";